
<spike-editable-panel 
  [title]="title()"
  [(isEditing)]="formView"
  (onSave)="save()"
  [isReadonly]="isReadOnly()"
  (onCancel)="formView.set(false)">
  @if(workflowPhase()){
  <spike-position-working-phase-form [workflowPhase] ="workflowPhase()!" [form]="form"></spike-position-working-phase-form>
  }
</spike-editable-panel>
